/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data IDs used in the logs filter component.
 */
export const LOGS_FILTER_DATA_IDS = {
  refreshButton: 'Button: Refresh logs',
  refreshButtonTooltip: 'Tooltip: Refresh logs button',
  searchBar: 'Logs search: Filter logs',
};

/**
 * The delay in milliseconds before returning a debounced value.
 */
export const DEBOUNCE_DELAY = 500;
